var map = {
	"./0categorias-capas/atualidades-e-negocios/2.jpg": [
		157,
		1
	],
	"./0categorias-capas/celebridades-e-tv/2.jpg": [
		158,
		4
	],
	"./0categorias-capas/criancas-e-quadrinhos/2.jpg": [
		159,
		7
	],
	"./0categorias-capas/decoracao-e-jardinagem/2.jpg": [
		160,
		10
	],
	"./0categorias-capas/especializadas/2.jpg": [
		161,
		13
	],
	"./0categorias-capas/esportes/2.jpg": [
		162,
		16
	],
	"./0categorias-capas/estilo-de-vida-e-moda/2.jpg": [
		163,
		19
	],
	"./0categorias-capas/games-e-tecnologia/2.jpg": [
		164,
		22
	],
	"./0categorias-capas/gastronomia-e-receitas/2.jpg": [
		165,
		25
	],
	"./0categorias-capas/historia-e-educacao/2.jpg": [
		166,
		28
	],
	"./0categorias-capas/saude-e-bem-estar/2.jpg": [
		167,
		31
	],
	"./0categorias-capas/viagens-e-lazer/2.jpg": [
		168,
		34
	],
	"./almanaque-da-saude/2.jpg": [
		534,
		40
	],
	"./ana-maria/2.jpg": [
		535,
		43
	],
	"./arte-em-festas-infantis/2.jpg": [
		536,
		46
	],
	"./arte-em-patchwork/2.jpg": [
		537,
		49
	],
	"./auto-esporte/2.jpg": [
		538,
		52
	],
	"./aventuras-na-historia/2.jpg": [
		539,
		55
	],
	"./bichos-em-casa/2.jpg": [
		540,
		58
	],
	"./bicycling/2.jpg": [
		541,
		61
	],
	"./bons-fluidos/2.jpg": [
		542,
		64
	],
	"./caras/2.jpg": [
		543,
		67
	],
	"./carros-classicos-e-cia/2.jpg": [
		544,
		70
	],
	"./casa-&-ambiente-banheiros-&-lavabos/2.jpg": [
		545,
		73
	],
	"./casa-&-ambiente-bebes/2.jpg": [
		546,
		76
	],
	"./casa-&-ambiente-quartos-e-closets/2.jpg": [
		547,
		79
	],
	"./casa-&-ambiente-salas-&-livings/2.jpg": [
		548,
		82
	],
	"./casa-&-cozinhas-e-salas-de-almoco/2.jpg": [
		549,
		85
	],
	"./casa-&-decoracao/2.jpg": [
		550,
		88
	],
	"./casa-e-jardim/2.jpg": [
		551,
		91
	],
	"./casa-interiores-&-paisagismo/2.jpg": [
		552,
		94
	],
	"./casa-vogue/2.jpg": [
		553,
		97
	],
	"./casas-pequenas/2.jpg": [
		554,
		100
	],
	"./colecao-almanaque-saude/2.jpg": [
		555,
		103
	],
	"./conceito-av-noivas/2.jpg": [
		557,
		106
	],
	"./conceito-av/2.jpg": [
		556,
		109
	],
	"./conhecimento-pratico-lingua-portuguesa/2.jpg": [
		558,
		112
	],
	"./contigo-novelas/2.jpg": [
		560,
		115
	],
	"./contigo/2.jpg": [
		559,
		118
	],
	"./crescer/2.jpg": [
		561,
		121
	],
	"./decoracao-&-estilo-casa/2.jpg": [
		562,
		124
	],
	"./decoracao-e-estilo-festas/2.jpg": [
		563,
		127
	],
	"./decorando-albuns-scrapbooking/2.jpg": [
		564,
		130
	],
	"./dinheiro-rural/2.jpg": [
		565,
		133
	],
	"./disney-historias/2.jpg": [
		566,
		136
	],
	"./epoca-negocios/2.jpg": [
		568,
		139
	],
	"./epoca/2.jpg": [
		567,
		142
	],
	"./espresso/2.jpg": [
		569,
		145
	],
	"./figurino-noivas/2.jpg": [
		570,
		148
	],
	"./filosofia-ciencia-&-vida/2.jpg": [
		571,
		151
	],
	"./fotografe-melhor/2.jpg": [
		572,
		154
	],
	"./fusca-e-cia-especial/2.jpg": [
		574,
		157
	],
	"./fusca-e-cia/2.jpg": [
		573,
		160
	],
	"./galileu/2.jpg": [
		575,
		163
	],
	"./gestao-&-negocios/2.jpg": [
		576,
		166
	],
	"./glamour/2.jpg": [
		577,
		169
	],
	"./globo-rural/2.jpg": [
		578,
		172
	],
	"./go-outside/2.jpg": [
		579,
		175
	],
	"./gq/2.jpg": [
		580,
		178
	],
	"./guia-artesanato/2.jpg": [
		581,
		181
	],
	"./guia-astral/2.jpg": [
		582,
		184
	],
	"./guia-conhecer-fantastico/2.jpg": [
		583,
		187
	],
	"./guia-curso-de-desenho/2.jpg": [
		584,
		190
	],
	"./guia-da-cozinha-festa/2.jpg": [
		585,
		193
	],
	"./guia-da-tv/2.jpg": [
		586,
		196
	],
	"./guia-de-cifras-musicais/2.jpg": [
		587,
		199
	],
	"./guia-de-cozinha/2.jpg": [
		588,
		202
	],
	"./guia-de-culinaria/2.jpg": [
		589,
		205
	],
	"./guia-de-decoracao/2.jpg": [
		590,
		208
	],
	"./guia-de-guerras/2.jpg": [
		591,
		211
	],
	"./guia-de-receitas-saudaveis/2.jpg": [
		593,
		214
	],
	"./guia-de-receitas/2.jpg": [
		592,
		217
	],
	"./guia-de-tecnologia/2.jpg": [
		594,
		220
	],
	"./guia-lazer-e-turismo/2.jpg": [
		595,
		223
	],
	"./guia-minha-saude/2.jpg": [
		596,
		226
	],
	"./guia-play-games/2.jpg": [
		597,
		229
	],
	"./guia-pratico-do-professor-educacao-infantil/2.jpg": [
		598,
		232
	],
	"./hardcore/2.jpg": [
		599,
		235
	],
	"./historia-em-foco/2.jpg": [
		600,
		238
	],
	"./historias-infantis/2.jpg": [
		601,
		241
	],
	"./hit/2.jpg": [
		602,
		244
	],
	"./humanitas/2.jpg": [
		603,
		247
	],
	"./istoe-dinheiro/2.jpg": [
		605,
		249
	],
	"./istoe/2.jpg": [
		604,
		252
	],
	"./ladybug-historias/2.jpg": [
		606,
		255
	],
	"./leituras-da-historia/2.jpg": [
		607,
		258
	],
	"./locaweb/2.jpg": [
		608,
		261
	],
	"./lucre-com-arte/2.jpg": [
		609,
		264
	],
	"./malu/2.jpg": [
		610,
		267
	],
	"./manequim/2.jpg": [
		611,
		270
	],
	"./marie-claire/2.jpg": [
		612,
		273
	],
	"./masha-e-o-urso-historias/2.jpg": [
		613,
		276
	],
	"./maxima-receitas/2.jpg": [
		614,
		279
	],
	"./mente-curiosa/2.jpg": [
		615,
		282
	],
	"./meu-proprio-negocio/2.jpg": [
		616,
		285
	],
	"./minecraft-quadrinhos/2.jpg": [
		617,
		288
	],
	"./minha-novela/2.jpg": [
		618,
		291
	],
	"./moda-moldes/2.jpg": [
		619,
		294
	],
	"./motor-show/2.jpg": [
		620,
		297
	],
	"./mundo-dos-super-herois/2.jpg": [
		621,
		300
	],
	"./mundo-em-foco/2.jpg": [
		622,
		303
	],
	"./natureza/2.jpg": [
		623,
		306
	],
	"./o-pequeno-ninja/2.jpg": [
		624,
		309
	],
	"./o-poder-dos-alimentos/2.jpg": [
		625,
		312
	],
	"./opala-&-cia/2.jpg": [
		626,
		315
	],
	"./patrulha-canina-livro-de-historia/2.jpg": [
		627,
		318
	],
	"./pegn/2.jpg": [
		628,
		321
	],
	"./peppa-pig/2.jpg": [
		629,
		324
	],
	"./pequenos-ambientes/2.jpg": [
		630,
		327
	],
	"./personalidades/2.jpg": [
		631,
		330
	],
	"./pilates/2.jpg": [
		632,
		333
	],
	"./playstation-revista-oficial/2.jpg": [
		633,
		336
	],
	"./ponto-cruz-faca-facil/2.jpg": [
		634,
		339
	],
	"./projetos-escolares/2.jpg": [
		635,
		342
	],
	"./psique/2.jpg": [
		636,
		345
	],
	"./receitas-e-delicias-caseiras/2.jpg": [
		638,
		348
	],
	"./receitas-e-delicias/2.jpg": [
		637,
		351
	],
	"./recreio/2.jpg": [
		639,
		354
	],
	"./revista-de-culinaria/2.jpg": [
		640,
		357
	],
	"./revista-oficial-xbox/2.jpg": [
		641,
		360
	],
	"./rolling-stone-edicao-especial/2.jpg": [
		643,
		363
	],
	"./rolling-stone/2.jpg": [
		642,
		366
	],
	"./runners/2.jpg": [
		644,
		369
	],
	"./salmos-e-anjos/2.jpg": [
		645,
		372
	],
	"./segredos-da-mente/2.jpg": [
		646,
		375
	],
	"./selecoes/2.jpg": [
		647,
		378
	],
	"./select/2.jpg": [
		648,
		381
	],
	"./sport-life/2.jpg": [
		649,
		384
	],
	"./sportbuzz/2.jpg": [
		650,
		387
	],
	"./tititi/2.jpg": [
		651,
		390
	],
	"./tpm/2.jpg": [
		652,
		393
	],
	"./trip/2.jpg": [
		653,
		396
	],
	"./uma/2.jpg": [
		654,
		399
	],
	"./vegan-fitness/2.jpg": [
		655,
		402
	],
	"./vegetarianos/2.jpg": [
		656,
		405
	],
	"./viaje-mais-luxo/2.jpg": [
		658,
		408
	],
	"./viaje-mais/2.jpg": [
		657,
		411
	],
	"./viva-bem/2.jpg": [
		659,
		414
	],
	"./viva-saude/2.jpg": [
		660,
		417
	],
	"./vogue/2.jpg": [
		661,
		420
	],
	"./womens-health/2.jpg": [
		662,
		423
	],
	"./yoga/2.jpg": [
		663,
		426
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 206;
module.exports = webpackAsyncContext;